<div class="container px-0">
  <div id="banner" class="banner">
    <img
      class="img-fluid w-100"
      src="/angular/browser/img/FP_LOGO_1700x628.jpg"
      alt="Álláshirdetések"
    />
  </div>
  <h1 class="text-center my-5">Álláshirdetések</h1>

  <div *ngIf="loading" class="career-loader text-center my-5">
    <div
      class="spinner-border text-danger"
      role="status"
      aria-hidden="true"
    ></div>
  </div>

  <div *ngIf="!loading">
    <div *ngIf="data.length > 0; then thenBlock; else elseBlock"></div>

    <ng-template #thenBlock>
      <div
        class="card mb-3 shadow-lg p-3 mb-5 bg-white rounded"
        *ngFor="let item of data"
      >
        <div class="card-body">
          <div class="d-flex align-items-center mb-2">
            <strong class="me-auto h5 mb-0"><b>{{ item.title }}</b></strong>
            <a
              [href]="
                '/allas/' + (item.job_id || item.secured_id || item.public_id)
              "
              class="btn btn-danger rounded-0"
            >
              Részletek
            </a>
          </div>

          <div class="mb-2">
            <span class="career-badge me-1" *ngFor="let wf of item.workfields">
              <img
                [src]="getIconPath('workfields')"
                alt=""
                class="career-badge-icon"
              />
              <strong>{{ wf.name }}</strong>
            </span>
            <span
              class="career-badge me-1"
              *ngIf="item.employment?.[0]?.name"
            >
              <img
                [src]="getIconPath('employment')"
                alt=""
                class="career-badge-icon"
              />
              <strong>{{ item.employment[0].name }}</strong>
            </span>
            <span class="career-badge me-1" *ngIf="item.addresses?.[0]?.city">
              <img
                [src]="getIconPath('city')"
                alt=""
                class="career-badge-icon"
              />
              <strong>{{ item.addresses[0].city }}</strong>
            </span>
            <span class="career-badge me-1" *ngIf="item.education?.name">
              <img
                [src]="getIconPath('education')"
                alt=""
                class="career-badge-icon"
              />
              <strong>{{ item.education?.name }}</strong>
            </span>
          </div>

          <p class="mb-0">
            {{ getShortDescription(item.description) }}
          </p>
        </div>
      </div>
    </ng-template>

    <ng-template #elseBlock>
      <div class="row">
        <div class="col-12">
          <h1 class="text-center">
            Jelenleg nincs elérhető állásajánlatunk!
          </h1>
        </div>
      </div>
    </ng-template>
  </div>

  <div
    *ngIf="!loading && data.length > 0"
    class="d-flex justify-content-center mt-4 mb-5"
  >
    <career-pagination
      [currentPage]="currentPage"
      [totalPages]="totalPages"
      [limit]="limit"
      [pageSizeOptions]="[5, 10, 20, 50]"
      (paginationChange)="onPaginationChange($event)"
    ></career-pagination>
  </div>
</div>
